let config = {
  AppsAPIURL: "https://apps-api.jewelcloud.com/api",
  AdminAPIURL: "https://admin-api.jewelcloud.com/api",
  DealerAPIURL: "https://dealer-api.jewelcloud.com/api",
};
// let config = {
//   AppsAPIURL: "https://jc2-apps-api.mgr.brainvire.net/api",
//   AdminAPIURL: "https://jc2-admin-api.mgr.brainvire.net/api"
// };
// let config = {
//   AppsAPIURL: "https://gem-appsapi-demo.brainvire.net/api"
// };

export default config;
